import type { useAuthStore } from "@/features/auth/store"

type AuthSnapshot = ReturnType<typeof useAuthStore.getState>

/**
 * True once auth settled and the stored profile was loaded for the signed-in user.
 * On an account switch without sign-out, auth-runtime keeps the previous account's
 * profile until the new one loads, and keeps it if that fetch fails, so
 * `profile !== null` alone could confirm the stub "free" plan of the new account.
 */
export function selectSalesCloserReady(state: AuthSnapshot): boolean {
  if (state.isLoading || !state.profile || !state.user) return false
  return state.profileUserId === state.user.id
}
